import HomeView from '../views/HomeView.vue'
import MainLayout from '../layouts/MainLayout.vue'
import MyPagesLayout from '../layouts/MyPagesLayout.vue'
import MyPagesSimpleLayout from '../layouts/MyPagesSimpleLayout.vue'
import OrganizationLayout from '../layouts/OrganizationLayout.vue'
import { OrganizationPath, OrganizationRouteName, ORGANIZATION_ROOT_SEGMENT } from './organizationPaths'
import { MainPath } from './mainPaths'
import { MyPagesPath, MyPagesRouteName, ParticipantSegment, ParticipantRouteName } from './myPagesPaths'


export default [
  {
    path: MainPath.HOME,
    name: 'home',
    component: HomeView,
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.TERMS_AND_CONDITIONS,
    name: 'termsAndConditions',
    component: () => import(/* webpackChunkName: "main" */ '../views/legal/TermsAndConditions.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: 'login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: 'password-reset',
    name: 'password-reset',
    component: () => import(/* webpackChunkName: "auth" */ '../views/PasswordResetView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: 'reset-password',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "auth" */ '../views/ResetPasswordView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: 'verify-email',
    name: 'verify-email',
    component: () => import(/* webpackChunkName: "auth" */ '../views/VerifyEmailView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: 'signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/signupFlow/SimpleSignupView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: 'new-organization',
    name: 'new-organization',
    component: () => import(/* webpackChunkName: "wizard" */ '../views/myPages/NewOrganizationView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: OrganizationPath.SIGNUP_PARTICIPANT,
    name: 'signup-participant',
    component: () => import(/* webpackChunkName: "participant-signup" */ '../views/signupFlow/ParticipantSignupView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.PRICING,
    name: 'pricing',
    component: () => import(/* webpackChunkName: "pricing" */ '../views/PricingView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.FEATURES,
    name: 'features',
    component: () => import(/* webpackChunkName: "features" */ '../views/FeaturesView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.FAQ,
    name: 'faq',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FaqView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.PRICING_ORGANIZATION,
    name: 'pricing-organization',
    component: () => import(/* webpackChunkName: "pricing" */ '../views/PricingOrganizationView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.PRIVACY,
    name: 'privacy',
    component: () => import(/* webpackChunkName: "legal" */ '../views/legal/PrivacyView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.TERMS,
    name: 'terms',
    component: () => import(/* webpackChunkName: "legal" */ '../views/legal/TermsView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: MainPath.TERMS_TRAINER,
    name: 'termsTrainer',
    component: () => import(/* webpackChunkName: "legal" */ '../views/legal/TermsView.vue'),
    meta: {
      layout: MainLayout,
      termsType: 'trainer'
    }
  },
  {
    path: MainPath.COOKIES,
    name: 'cookies',
    component: () => import(/* webpackChunkName: "legal" */ '../views/legal/CookiesView.vue'),
    meta: {
      layout: MainLayout
    }
  },
  {
    path: `${ORGANIZATION_ROOT_SEGMENT}/:identifier`,
    component: () => import(/* webpackChunkName: "organization-pages" */ '@/layouts/OrganizationLayout.vue'),
    meta: {
      layout: OrganizationLayout
    },
    children: [
      {
        path: '',
        name: 'OrganizationView',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/OrganizationView.vue')
      },
      {
        path: 'class/:class',
        name: 'ClassView',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/ClassView.vue'),
      },
      {
        path: OrganizationPath.MEMBERSHIPS,
        name: OrganizationRouteName.MEMBERSHIPS,
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/OrganizationMembershipsView.vue')
      },
      {
        path: OrganizationPath.CONTACTS,
        name: OrganizationRouteName.CONTACTS,
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/OrganizationContactsView.vue')
      },
      {
        path: 'registration-confirming-payment',
        name: 'join-confirming-payment',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/JoinEventPaymentConfirmingView.vue')
      },
      {
        path: 'registration-completed',
        name: 'join-completed',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/JoinEventThankYouView.vue')
      },
      {
        path: 'registration-pending-payment',
        name: 'join-pending-payment',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/JoinEventPendingPaymentView.vue')
      },
      {
        path: 'registration-request-received',
        name: 'join-request-received',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/JoinEventRequestReceivedView.vue')
      },
      {
        path: 'registration-pending-waitlisted',
        name: 'join-pending-waitlisted',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/JoinEventRequestReceivedView.vue')
      },
      {
        path: 'cancel-event/:eventUuid/:participantUuid',
        name: 'cancel-event',
        component: () => import(/* webpackChunkName: "organization-pages" */ '@/views/organization/CancelEventView.vue')
      },
      {
        path: 'login',
        name: 'organization-login',
        component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
      },
      {
        path: OrganizationPath.SIGNUP_PARTICIPANT,
        name: OrganizationRouteName.SIGNUP_PARTICIPANT,
        component: () => import(/* webpackChunkName: "participant-signup" */ '../views/signupFlow/ParticipantSignupView.vue')
      },
      {
        path: 'password-reset',
        name: 'organization-password-reset',
        component: () => import(/* webpackChunkName: "auth" */ '../views/PasswordResetView.vue')
      },
      {
        path: 'reset-password',
        name: 'organization-reset-password',
        component: () => import(/* webpackChunkName: "auth" */ '../views/ResetPasswordView.vue')
      },
    ]
  },
  {
    path: 'welcome-wizard',
    name: 'welcome-wizard',
    component: () => import(/* webpackChunkName: "wizard" */ '../views/myPages/WelcomeWizardView.vue'),
    meta: {
      layout: MyPagesSimpleLayout,
      requiresAuth: true
    }
  },
  {
    path: 'verify-email',
    name: 'verify-email',
    component: () => import(/* webpackChunkName: "verify-email" */ '../views/VerifyEmailView.vue'),
    meta: {
      layout: MyPagesSimpleLayout,
      requiresAuth: true
    }
  },
  {
    path: 'mypages',
    component: () => import(/* webpackChunkName: "mypages" */ '@/layouts/MyPagesLayout.vue'),
    meta: {
      layout: MyPagesLayout,
      requiresAuth: true
    },
    children: [
      /** User profile settings – always accessible to any logged-in user (no account context required) */
      {
        path: 'account',
        name: 'UserProfileSettings',
        component: () => import(/* webpackChunkName: "mypages" */ '../views/myPages/UserAccountSettingsView.vue'),
        meta: {
          allowWithoutAccountContext: true
        }
      },

      /** Participant views */
      {
        path: ParticipantSegment.ROOT,
        component: () => import(/* webpackChunkName: "mypages" */ '../layouts/TransitionLayout.vue'),
        meta: {
          requiresParticipant: true,
          requiresEmailVerification: true,
          orgIdentifier: ParticipantSegment.ROOT //This is for account validation
        },
        children: [
          {
            path: '',
            name: ParticipantRouteName.DASHBOARD_ROOT,
            component: () => import(/* webpackChunkName: "participant" */ '../views/myParticipant/ParticipantDashboardView.vue'),
          },
          {
            path: ParticipantSegment.DASHBOARD,
            name: ParticipantRouteName.DASHBOARD,
            component: () => import(/* webpackChunkName: "participant" */ '../views/myParticipant/ParticipantDashboardView.vue'),
          },
          {
            path: ParticipantSegment.PURCHASES,
            name: ParticipantRouteName.PURCHASES,
            component: () => import(/* webpackChunkName: "participant" */ '../views/myParticipant/ParticipantPurchasesView.vue'),
          },
          /** Email verification views */
          {
            path: ParticipantSegment.EMAIL_VERIFICATION,
            name: ParticipantRouteName.EMAIL_VERIFICATION,
            component: () => import(/* webpackChunkName: "mypages" */ '../views/VerifyEmailView.vue'),
            meta: {
              requiresEmailVerification: false
            }
          }
        ]
      },
      /** Organization views */
      {
        path: 'o/:orgIdentifier',
        component: () => import(/* webpackChunkName: "mypages" */ '../layouts/TransitionLayout.vue'),
        meta: {
          requiresOrganization: true
        },
        children: [
          {
            path: '',
            name: 'EventsPage',
            component: () => import(/* webpackChunkName: "organization" */ '../views/myPages/MyEventsView.vue')            
          },
          {
            path: 'dashboard',
            name: 'Dashboard',
            component: () => import(/* webpackChunkName: "organization" */ '../views/myPages/MyPagesDashboardView.vue')            
          },
          {
            path: MyPagesPath.CLASSES,
            name: MyPagesRouteName.CLASSES,
            component: () => import(/* webpackChunkName: "organization" */ '../views/myPages/MyClassesView.vue')
          },
          {
            path: MyPagesPath.EVENTS,
            name: MyPagesRouteName.EVENTS,
            component: () => import(/* webpackChunkName: "organization" */ '../views/myPages/MyEventsView.vue')
          },
          {
            path: MyPagesPath.PARTICIPANTS,
            name: MyPagesRouteName.PARTICIPANTS,
            component: () => import(/* webpackChunkName: "organization" */ '../views/myPages/MyParticipantsView.vue')
          },
          {
            path: MyPagesPath.MEMBERSHIPS,
            name: MyPagesRouteName.MEMBERSHIPS,
            component: () => import(/* webpackChunkName: "organization" */ '../views/myPages/organization/MembershipsView.vue')
          },
          {
            path: MyPagesPath.MEMBERSHIP_TEMPLATES,
            name: MyPagesRouteName.MEMBERSHIP_TEMPLATES,
            component: () => import(/* webpackChunkName: "organization" */ '../views/myPages/organization/MembershipTemplatesPageView.vue')
          },
          /** Settings area: one index, one page per section. Section list: src/domains/settings/settingsSections.js */
          {
            path: MyPagesPath.SETTINGS,
            name: MyPagesRouteName.SETTINGS,
            component: () => import(/* webpackChunkName: "settings" */ '../views/myPages/settings/SettingsIndexView.vue')
          },
          {
            path: MyPagesPath.MY_SITE,
            name: MyPagesRouteName.MY_SITE,
            component: () => import(/* webpackChunkName: "settings" */ '../views/myPages/MySiteView.vue')
          },
          {
            path: MyPagesPath.SETTINGS_GENERAL_RULES,
            name: MyPagesRouteName.SETTINGS_GENERAL_RULES,
            component: () => import(/* webpackChunkName: "settings" */ '../views/myPages/settings/GeneralRulesSettingsView.vue')
          },
          {
            path: MyPagesPath.SETTINGS_SERVICES_PRICING,
            name: MyPagesRouteName.SETTINGS_SERVICES_PRICING,
            component: () => import(/* webpackChunkName: "settings" */ '../views/myPages/settings/ServicesPricingSettingsView.vue')
          },
          {
            path: MyPagesPath.SETTINGS_ONLINE_PAYMENTS,
            name: MyPagesRouteName.SETTINGS_ONLINE_PAYMENTS,
            component: () => import(/* webpackChunkName: "settings" */ '../views/myPages/settings/OnlinePaymentsSettingsView.vue')
          },
          {
            path: MyPagesPath.SETTINGS_TEAM,
            name: MyPagesRouteName.SETTINGS_TEAM,
            component: () => import(/* webpackChunkName: "settings" */ '../views/myPages/settings/TeamSettingsView.vue')
          },
          {
            path: MyPagesPath.SETTINGS_ACCOUNT,
            name: MyPagesRouteName.SETTINGS_ACCOUNT,
            component: () => import(/* webpackChunkName: "settings" */ '../views/myPages/settings/AccountSettingsView.vue')
          },
          /** Legacy URLs. `settings?tab=` is handled inside SettingsIndexView. */
          {
            path: MyPagesPath.LEGACY_SERVICES_SETTINGS,
            name: MyPagesRouteName.LEGACY_SERVICES_SETTINGS,
            redirect: { name: MyPagesRouteName.SETTINGS_GENERAL_RULES }
          },
          {
            path: MyPagesPath.LEGACY_MEMBERSHIP_SETTINGS,
            name: MyPagesRouteName.LEGACY_MEMBERSHIP_SETTINGS,
            redirect: { name: MyPagesRouteName.SETTINGS_SERVICES_PRICING }
          }
        ]
      },
    ]
  },
      
  
  {
    path: '*',
    name: 'PageNotFound',
    component: () => import(/* webpackChunkName: "error" */ '../views/ErrorView.vue'),
  }
]